import React, { Component } from "react";

import Button from "./shared/Button";
import GutterGridItem from "./grid/GutterGridItem";
import Footer from "./shared/Footer";
import LocalizedLink from "../containers/LocalizedLink";


import ActionsImage from "../images/actions.jpg";
import CollectionsImage from "../images/collections.jpg";
import ClassicsImage from "../images/classics.jpg";

import { patternsByCollectionIds } from "../constants/patterns.js";

const HEADER_OFFSET = 103;

class PatternsList extends Component {
  constructor(props) {
    super(props);

    this.actionsRef = null;
    this.collectionsRef = null;
    this.classicsRef = null;
    this.handleScrollToRef = this.handleScrollToRef.bind(this);
  }

  handleScrollToRef(sectionRef) {
    const offset = sectionRef.offsetTop - HEADER_OFFSET;

    if (window.scroll) {
      window.scroll({ top: offset, behavior: "smooth" });
    } else {
      window.scrollTo(0, offset);
    }
  }

  render() {
    return (
      <React.Fragment>
        <section className="grid grid--2 grid--fixed" style={{ top: "55px" }}>
          <LocalizedLink className="grid__item" to="/collections/surfaces">
            <div className="grid__item-title">{this.props.t("titleSurfaces")}</div>
          </LocalizedLink>
          <LocalizedLink className="grid__item" to="/collections/patterns">
            <div className="grid__item-title font-bold">{this.props.t("titlePatterns")}</div>
          </LocalizedLink>
        </section>

        <section className="grid grid--3" style={{ marginTop: "104px" }}>
          <div
            className="grid__item"
            style={{ backgroundImage: `url(${ActionsImage})` }}
          >
            <div className="grid__item-image" />
            <div className="grid__item-label">
              <div className="font-light f3 pb3">{this.props.t("common:labelActions55")}</div>
              <div className="grid__item-text">
                {this.props.t("action55Description")}
              </div>


              <Button
                label={this.props.t("discoverbutton")}
                onClick={() => this.handleScrollToRef(this.actionsRef)}
              />
            </div>
          </div>

          <div
            className="grid__item"
            style={{ backgroundImage: `url(${CollectionsImage})` }}
          >
            <div className="grid__item-image" />
            <div className="grid__item-label">
              <div className="font-light f3 pb3">{this.props.t("common:labelCollections55")}</div>
              <div className="grid__item-text">
                {this.props.t("collections55Description")}
              </div>
              <Button
                label={this.props.t("discoverbutton")}
                onClick={() => this.handleScrollToRef(this.collectionsRef)}
              />
            </div>
          </div>

          <div
            className="grid__item"
            style={{ backgroundImage: `url(${ClassicsImage})` }}
          >
            <div className="grid__item-image" />
            <div className="grid__item-label">
              <div className="font-light f3 pb3">{this.props.t("common:labelClassics")}</div>
              <div className="grid__item-text">
                {this.props.t("classicsDescription")}
              </div>
              <Button
                label={this.props.t("discoverbutton")}
                onClick={() => this.handleScrollToRef(this.classicsRef)}
              />
            </div>
          </div>
        </section>

        {/* Actions 5•5 */}
        <section
          className="w-100 bt b--black pv8"
          ref={ref => (this.actionsRef = ref)}
        >
          <div className="pb5 f3 font-bold tc">{this.props.t("common:labelActions55")}</div>
          {/* Create component + MAP Constant Array */}
          <div className="gutter-grid gutter-grid--6">
            {patternsByCollectionIds[1].map((pattern, key) => (
              <GutterGridItem key={key} pattern={pattern} lng={this.props.lng}/>
            ))}
          </div>

          <div className="w-100 tc">
          <LocalizedLink className="button button--large" to="/create">
          {this.props.t('common:labelCreateYourModel')}&nbsp;
            <i className="button__icon i-arrow-right-light" />
          </LocalizedLink>
          </div>
        </section>

        {/* Collections 5•5 */}
        <section
          className="w-100 bt b--black pv8"
          ref={ref => (this.collectionsRef = ref)}
        >
          <div className="pb5 f3 font-bold tc">{this.props.t("common:labelCollections55")}</div>
          {/* Create component + MAP Constant Array */}
          <div className="gutter-grid gutter-grid--6">
            {patternsByCollectionIds[2].map((pattern, key) => (
              <GutterGridItem key={key} pattern={pattern} lng={this.props.lng}/>
            ))}
          </div>

          <div className="w-100 tc">
          <LocalizedLink className="button button--large" to="/create">
          {this.props.t('common:labelCreateYourModel')}&nbsp;
            <i className="button__icon i-arrow-right-light" />
          </LocalizedLink>
          </div>
        </section>

        {/* Classiques */}
        <section
          className="w-100 bt b--black pv8"
          ref={ref => (this.classicsRef = ref)}
        >
          <div className="pb5 f3 font-bold tc" ref={this.myRef}>{this.props.t("common:labelClassics")}</div>
          {/* Create component + MAP Constant Array */}
          <div className="gutter-grid gutter-grid--6">
            {patternsByCollectionIds[0].map((pattern, key) => (
              <GutterGridItem key={key} pattern={pattern} lng={this.props.lng}/>
            ))}
          </div>

          <div className="w-100 tc">
          <LocalizedLink className="button button--large" to="/create">
          {this.props.t('common:labelCreateYourModel')}&nbsp;
            <i className="button__icon i-arrow-right-light" />
          </LocalizedLink>
          </div>
        </section>

        <Footer t={this.props.t} />

      </React.Fragment>
    );
  }
}

export default PatternsList;



// WEBPACK FOOTER //
// ./src/components/PatternsList.js